import { Component, OnInit, Output, Input, ViewChild, ElementRef, EventEmitter, HostListener } from '@angular/core';
import {LocalStorageService } from '../../local-storage.service'

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})

export class SearchComponent implements OnInit {

    @ViewChild('searchInput', { static: true }) searchInput: ElementRef;
    @Output() search: EventEmitter<string> = new EventEmitter<string>(); 
    @Output() multipleInput: EventEmitter<string> = new EventEmitter<string>(); 

    @Output() multiSearch: EventEmitter<string> = new EventEmitter<string>(); 

    @Input() data: any;
    filter: any;
    selectedValue: any = {};
    constructor(private eRef: ElementRef, private storage:LocalStorageService) { }

  showSearchContent: boolean = false;
  searchCard: boolean = false;
  custom_fitler_enable: boolean = false;
  custom_fitler_initiated: boolean = false;
  live_data_filter = "Live Data"
  device_data_filter = "Device Data"
  custom_search_data;
  showContent() {
      this.showSearchContent = !this.showSearchContent;
  }
  hideContent(){
    this.showSearchContent = false;
    if(JSON.stringify(this.selectedValue) != '{}' && this.custom_fitler_initiated){
      let value = ''
      this.custom_fitler_enable = true;
      for(let key in this.selectedValue){
        value += this.selectedValue[key] + ', '
      }
      this.selectedValue = {}
      this.custom_search_data = value;
    }else{
      this.selectedValue = {}
    }
  }
  onBlur(event) {
    this.searchInput.nativeElement.onfocus();  
  }

  ngOnInit() {
    if(this.storage.isCheck(this.live_data_filter)){
      this.filterChartValue(this.live_data_filter)
    }else if(this.storage.isCheck(this.device_data_filter)){
      this.filterChartValue(this.device_data_filter)
    }
  }

  filterChartValue(chartValue){
    this.selectedValue = this.storage.getData(chartValue)
    this.custom_fitler_initiated = true;
    this.search.emit(this.selectedValue);
    this.hideContent()
    this.storage.removeData(chartValue)
  }
    applyFilter(filterValue) {
        this.search.emit(filterValue);
       
    }
    filterChange(filter, event, selectedValue) {
        this.multipleInput.emit(selectedValue);
        
        //let filterValues = {}
     //   this.filterValues[filter.columnProp] = event.target.value.trim().toLowerCase()
      //  this.dataSource.filter = JSON.stringify(this.filterValues)
    }

    reset() {
        this.selectedValue = {};
        this.search.emit(this.selectedValue);
    }

    

    searchSubmit(selectedValue){
      this.custom_fitler_initiated = true;
      this.search.emit(selectedValue);
    }

    // @HostListener('document:click', ['$event'])
    // clickout(event) {
    //     if (this.eRef.nativeElement.contains(event.target)) {
    //         // this.showSearchContent = true;
    //     } else {
    //         // this.showSearchContent = false;
    //     }
    // }


  searchOpens(){
      this.searchCard = true;
    }
    input1() {

    }
    input2() {

    }
    

}
